import React, { Component } from 'react';
import {realPath} from './util'
import imagePrecache from './ImagePrecache'
import {styles} from '../../config'

export default class LazyImage extends Component {
	state = {
		//aspect: 0, 
		url: null,
		classes: []
	}
	componentWillMount() {
		const { src, imageStyle, screen} = this.props
	
		//this.setState({classes: [className]})
		if (screen && src.srcset) {
			const srcset = src.srcset.filter(item => 
				(!item.mq || item.mq.length===0 || item.mq.includes(screen.mq)) && 
				(!item.o || item.o.length===0 || item.o.includes(screen.o)) &&
				(!item.r || item.r.length===0 || item.r.includes(screen.r))
			)
			if (srcset.length ===0) this.setState({url: realPath(src.url, imageStyle)})
			else  this.setState({url: realPath(srcset[0].src, imageStyle)})
			return
		}
		
		this.setState({url: realPath(src.url, imageStyle)})
	}
	/*
	onAspectChange = (aspect, real, index) => {
		const {proportional, container} = this.props
		
		if(this.props.onAspectChange) this.props.onAspectChange(aspect, real, index)
		if(proportional && container) {
			const el = document.querySelector(container)
			if(el) el.style.paddingBottom = aspect
		}
	}
	*/
	componentDidMount() {
		const { bg, src, proportional, container, imageStyle} = this.props
		
		this.mounted = true
		const el = container?document.querySelector(container):null
		if(el) el.style.paddingBottom = null
		if(proportional) {
			if(container) {
				const aspect = imageStyle
					?(styles[imageStyle][1]/styles[imageStyle][0]*100)
					:(src.h?(src.h / src.w * 100):1)
				if(el) el.style.paddingBottom = `${aspect}%`
			}
			imagePrecache.preload(src.th, true, (w,h, cached) => {
				if(!this.mounted) return
				/*let aspect = (h/w*100) + '%'
				this.setState({aspect})
				this.onAspectChange(aspect, false, this.props.index)*/
			})
		}
		setTimeout(() => this.loadImage(bg, this.state.url))
	}
	componentWillUnmount() {
		this.mounted = false
		this.img = null
	}
	componentWillReceiveProps(nextProps) {
		const { src, imageStyle, screen } = nextProps
		
		if (screen && src.srcset) {
			//if (mq===this.props.mq && o===this.props.o) return
			const srcset = src.srcset.filter(item => 
				(!item.mq || item.mq.length===0 || item.mq.includes(screen.mq)) && 
				(!item.o || item.o.length===0 || item.o.includes(screen.o)) &&
				(!item.r || item.r.length===0 || item.r.includes(screen.r))
			)
			//const srcset = src.srcset.filter(item => item.mq.includes(mq) && item.o.includes(o))
			if (srcset.length ===0) this.setState({url: realPath(src.url, imageStyle)})
			else  this.setState({url: realPath(srcset[0].src, imageStyle)})
			if(this.img) this.img.classList.remove('lazy-loaded', 'lazy-cache-loaded')
			return
		}
		
		if (src.url === this.props.src.url) return
		this.setState({url: realPath(src.url, imageStyle)})
		
		if(this.img) this.img.classList.remove('lazy-loaded', 'lazy-cache-loaded')
	}
	componentDidUpdate(prevProps, prevState) {
		const { src, screen } = prevProps

		if (screen && src.srcset) {
			setTimeout(() => this.loadImage(this.props.bg, this.state.url))
			return
		}
		if (src.url === this.props.src.url) return
		setTimeout(() => this.loadImage(this.props.bg, this.state.url))
	}
	loadImage(bg, url) {
		if (!url || !this.img) return
		
		imagePrecache.preload(url, false, (w,h, cached) => {
			if(!this.mounted) return
			if(bg) this.img.style.backgroundImage = "url('" + url + "')"
			else this.img.src = url
			this.img.classList.add(cached?'lazy-loaded':'lazy-cache-loaded')
			/*
			if(this.props.proportional) {
				let aspect = (h/w*100) + '%'
				this.setState({aspect})
				this.onAspectChange(aspect, true, this.props.index)
			}*/
		})
	}
	render() {
		const { bg, src, alt, className, proportional, imageStyle, style } = this.props
		//const {url} = this.state
		
		let img_src
		let classes = (className?className:'')
		img_src = src
		if (src.th) {
			img_src = 'data:image/jpeg;charset=utf-8;base64, ' + src.th
		} else img_src = src.url
			/*if(this.img) {
				img_src = url
				classes = `${classes} lazy-cache-loaded`
			}*/

		const aspect = imageStyle
			?(styles[imageStyle][1]/styles[imageStyle][0]*100)
			:src.h?(src.h / src.w * 100):1
		if (bg) {
			if (proportional) {
				return (
					<div className={classes + ' prop-container'} 
						style={{...style, height:0, paddingBottom: `${aspect}%`}}>
					<div ref={c => this.img = c} className='lazy '
						style={{backgroundImage: 'url(\'' + img_src + '\')'}}
						>
						{this.props.children}
					</div>
					</div>
				)
				
			}
			return (
				<div ref={c => this.img = c} className={classes + ' lazy'}
					style={{...style, backgroundImage: 'url(\'' + img_src + '\')'}}
					>
					{this.props.children}
				</div>
			)
		}
 
		return (
			<div className={classes + ' prop-container'} style={{...style, height:0, paddingBottom: `${aspect}%`}}>
				<img ref={c => this.img = c} src={img_src} className='lazy' alt={alt?alt:''} />
			</div>
		)
	}
}
//			<img ref={c => this.img = c} src={img_src} className={classes + ' lazy'} alt={alt?alt:''} />

/*
			<div className={classes + ' prop-container'} style={{height:0, paddingBottom: `${aspect}%`}}>
				<img ref={c => this.img = c} src={img_src} className='lazy' alt={alt?alt:''} />
			</div>
*/


// WEBPACK FOOTER //
// ./src/fm/lib/LazyImage.js